import Service from '../Service'
class PaymentConditionsService extends Service {
  constructor() {
    super('')
    this.resource = 'payment-conditions'
  }

  createRequestUrl(query = null) {
    let requestUrl = `${this.resource}?`

    if (query) {
      
      query = this.encodeQueryValues(query);
    
      if (query.todos)
        requestUrl += this.hasParameter(requestUrl)
          ? `&TODOS=${query.todos}`
          : `TODOS=${query.todos}`

      if (query.page)
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      if (query.codigo)
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`

      if (query.nome)
        requestUrl += this.hasParameter(requestUrl)
          ? `&NOME=${query.nome}`
          : `NOME=${query.nome}`

      if (query.cts)
        requestUrl += this.hasParameter(requestUrl)
          ? `&CTS=${query.cts}`
          : `CTS=${query.cts}`

      if (query.hibrido && query.hibrido.length > 0) {
        // consulta pelo codigo nome
        requestUrl += this.hasParameter(requestUrl)
          ? `&HIBRIDO=${query.hibrido}`
          : `HIBRIDO=${query.hibrido}`
      }
    }
    return requestUrl
  }

  async getValidCTs() {
    let requestUrl = `${this.resource}/index-cts`
    return await this.getAPI(requestUrl)
  }

  async getPaymentConditionsAPI(query = null) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async getPaymentConditionAPI(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    return await this.getAPI(requestUrl)
  }
}

export default new PaymentConditionsService()
